class Phone {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}`;
    this.apiClient = apiClient;

  }

  async tryEnablePhone(configuration) {

    const path = this.basePath + '/phone';

    return this.apiClient.post(path, {}, {}, configuration);

  }

  async tryDisablePhone(configuration) {

    const path = this.basePath + '/phone';

    return this.apiClient.delete(path, {}, {}, configuration);

  }

}

export default Phone;